var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-lg fill-currentColor flex gap-2 items-center bg-primary-container border border-primary rounded-xl p-2"},[(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }